module.exports = __webpack_public_path__ + "img/MAIN.319ff472.JPG";